import { useNavigate, useParams } from 'react-router-dom';
import { Card, Spin, Alert } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import SystemSettingForm from '../components/SystemSettingForm';
import { useSystemSettingDetails } from '../hooks/useSystemSettingQueries';
import { useUpdateSystemSetting } from '../hooks/useSystemSettingMutations';

export default function SystemSettingEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading } = useSystemSettingDetails(id);
  const mutation = useUpdateSystemSetting();

  const handleSubmit = (formData: any) => { (mutation.mutate as any)({ id: Number(id), data: formData }, { onSuccess: () => navigate('/system-settings') }); };

  if (isLoading) return <Spin style={{ display: 'block', margin: '80px auto' }} />;
  if (!data) return <Alert type="warning" message={t('systemSettings.notFound')} showIcon />;

  return (
    <div>
      <PageHeader back title={t('systemSettings.editTitle')} subtitle={`${t('common.editing')}: ${data.key}`} />
      <Card>
        {!data.editableByAdmin && <Alert type="warning" message={t('systemSettings.nonEditableWarning')} showIcon style={{ marginBottom: 16 }} />}
        <SystemSettingForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
